<template>
  <div class="container">
    <ul class="accordion-list">
      <li v-for="(criterion, index) in criteria" :key="index" class="accordion-item">
        <!-- タイトル行 -->
        <div class="accordion-header" @click="toggleDetail(index)">
          <span>{{ index + 1 }}. {{ criterion.title }}</span>
          <span class="toggle-icon">{{ openIndexes.includes(index) ? "▲" : "▼" }}</span>
        </div>

        <!-- 詳細カード -->
        <div v-if="openIndexes.includes(index)" class="accordion-body">
          <div class="card">
            <img :src="criterion.img" :alt="criterion.title" />
            <p class="item-detail" v-html="criterion.detail"></p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import img1 from "@/assets/criterion/1.png";
import img2 from "@/assets/criterion/2.png";
import img3 from "@/assets/criterion/3.png";
import img4 from "@/assets/criterion/4.png";
import img5 from "@/assets/criterion/5.png";

export default {
  name: "CriterionAccordion",
  data() {
    return {
      openIndexes: [0], // 最初は1つ目だけ開いた状態
      criteria: [
        {
          title: "設置までの総額費用が安い",
          img: img1,
          detail: `給湯器の本体価格や工事費は業者によって大きく異なり、
          <span class="bold-red">同じメーカーを設置する場合でも総額で数万円以上の差</span> が出ることがあります。<br><br>
          そこで、<span class="under-yellow">本体価格の割引率が高く、工事費を含めても相場より安い業者に厳選して紹介</span>しています。`
        },
        {
          title: "見積もりや相談が無料",
          img: img2,
          detail: `給湯器の交換は高額になりやすいため、<span class="bold-red">事前に費用感を把握できるかどうか</span>はとても重要です。<br><br>
          当サイトで紹介している業者は、<span class="under-yellow">見積もりや相談がすべて無料</span>なので、費用や工事内容を比較したうえで安心して依頼できます。`
        },
        {
          title: "施工実績が豊富",
          img: img3,
          detail: `施工実績が多ければ多いほど、経験と技術力が蓄積されており、スムーズな工事や幅広い住宅環境への対応が可能です。<br><br>
          <span class="bold-red">「実績の多さ＝多くの人に選ばれてきた証」</span>といえるため、<span class="under-yellow">信頼できる実績豊富な専門業者を取り上げています。</span>`
        },
        {
          title: "保証内容が充実している",
          img: img4,
          detail: `給湯器は10年以上使用する設備であるため、<span class="bold-red">設置後の不具合や故障にどう対応してくれるか</span>は非常に重要です。<br><br>
          万が一設置した給湯器にトラブルがあっても心配いらないよう、<span class="under-yellow">工事保証やアフターサービスの体制が充実している業者を選定</span>しています。`
        },
        {
          title: "口コミ・評判が高い",
          img: img5,
          detail: `口コミや評判は、<span class="bold-red">実際に依頼した人にしかわからないリアルな声</span>を知ることができるため、とても重要なポイントです。<br><br>
          合計15社の給湯器専門業者の口コミを調査し、<span class="under-yellow">高評価でレビュー数の多い業者を選定</span>しています。`
        }
      ]
    };
  },
  methods: {
    toggleDetail(index) {
      if (this.openIndexes.includes(index)) {
        this.openIndexes = this.openIndexes.filter(i => i !== index);
      } else {
        this.openIndexes.push(index);
      }
    }
  }
};
</script>

<style scoped>
.container {
  background: #fff9f1;
  padding: 20px;
}

.accordion-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.accordion-item {
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

.accordion-header {
  background: #f5f5f5;
  /* グレー背景 */
  color: #333;
  padding: 12px 16px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accordion-body {
  padding: 15px;
}

.card {
  background: #fff;
  text-align: center;
}

.card img {
  max-width: 60%;
  margin-bottom: 12px;
}

.item-detail {
  font-size: 0.95rem;
  text-align: left;
  line-height: 1.6;
}

.bold-red {
  color: #e53935;
}

.under-yellow {
  background: linear-gradient(transparent 60%, #ffff99 60%);
}

.toggle-icon {
  font-size: 0.9rem;
}

/* スマホ対応 */
@media (max-width: 600px) {
  .container {
    padding: 10px;
  }

  .accordion-header {
    font-size: 1rem;
    text-align: left;
    padding: 10px;
  }

  .card img {
    max-width: 80%;
  }

  .item-detail {
    font-size: 1rem;
  }
}
</style>
